import { render } from "./ManageType.vue?vue&type=template&id=32ac09ab&ts=true"
import script from "./ManageType.vue?vue&type=script&lang=ts"
export * from "./ManageType.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__